import { ModuleTile } from '../module-tile/module-tile.component';
import { DeliveryContainerTile } from '../delivery-container-tile/delivery-container-tile.component';
import { DeliveryContainerTileContent } from '../delivery-container-tile-content/delivery-container-tile-content.component';
import { KioskTileContent } from '../kiosk-tile-content/kiosk-tile-content.component';
import { TowerRendererProps } from './tower-renderer.types';

export function TowerRenderer({
  towers,
  maxModuleHeight,
  isInverted,
  interactive = false,
  hideTooltip,
  renderTooltipContent,
  renderLockerContent,
  makeLinkUrl,
  makeLinkRequiresPermissions,
  kioskScreenOrientation,
  onTowerTitleClick
}: TowerRendererProps) {
  const renderedTowers = isInverted ? [...towers].reverse() : towers;
  const shouldHideTooltip = hideTooltip ?? !interactive;

  return (
    <>
      {renderedTowers.map((tower) => (
        <ModuleTile
          key={tower.id}
          title={tower.title}
          pixelDimensions2D={tower.pixelDimensions2D}
          maxModuleHeight={maxModuleHeight}
          onTitleClick={onTowerTitleClick ? () => onTowerTitleClick(tower.id) : undefined}
        >
          {tower.lockers.map((locker) => (
            <DeliveryContainerTile
              key={locker.id}
              disablePointer={!interactive}
              pixelDimensions2D={locker.pixelDimensions2D}
              pixelPosition2D={
                isInverted && locker.invertedPixelPosition2D ? locker.invertedPixelPosition2D : locker.pixelPosition2D
              }
              backgroundColor={locker.backgroundColor}
              isHighlighted={locker.isHighlighted}
              highlightColor={locker.highlightColor}
              link={interactive && makeLinkUrl ? makeLinkUrl(locker.id) : undefined}
              linkRequiresPermissions={
                makeLinkRequiresPermissions ? makeLinkRequiresPermissions(locker) : locker.isKiosk
              }
              hideTooltip={shouldHideTooltip}
              tooltipContent={interactive && renderTooltipContent ? renderTooltipContent(locker.id) : undefined}
            >
              {renderLockerContent ? (
                renderLockerContent(locker) ?? (
                  <DeliveryContainerTileContent deliveryContainerName={locker.name} Icon={locker.sizeIcon} />
                )
              ) : locker.isKiosk ? (
                <KioskTileContent screenOnly hubType={tower.hubType} kioskScreenOrientation={kioskScreenOrientation} />
              ) : (
                <DeliveryContainerTileContent deliveryContainerName={locker.name} Icon={locker.sizeIcon} />
              )}
            </DeliveryContainerTile>
          ))}
        </ModuleTile>
      ))}
    </>
  );
}
